import { API, graphqlOperation, Storage } from 'aws-amplify';
//import unlayer from '@/util/unlayer-options';

export default {
    namespaced:true,
    state: {
        entity: 'NewsletterTemplate',
        list: null,
        listDirty: false,
        item: null,
        nextToken: null,
        previewImage: null,
        publicOnly: null,
    },
    mutations: {
        list: (state, payload) => { state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value; state.list.sort((a,b) => a.order - b.order) },
        listDirty: (state, payload) => { state.listDirty = payload.value },
        item: (state, payload) => { state.item = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value },
        publicOnly: (state, payload) => {state.publicOnly = payload.value }
    },
    getters: {
    },
    actions: {
        
        async get(context, payload) {
            const c = await API.graphql(graphqlOperation(`query GetNewsletterTemplate($id: ID!) {
              getNewsletterTemplate(id: $id) {
                id
                name
                public
                unlayerData
                preview
                order
              }}
                `, { id: payload.id }));
            
            let nst = c.data.getNewsletterTemplate;
            if(nst.grapesJSData) {
              nst.grapesJSData = JSON.parse(nst.grapesJSData);
            }
            if(nst.unlayerData) {
              nst.unlayerData = JSON.parse(nst.unlayerData);
            }
            if(nst.preview) {
              nst.preview = await Storage.get(nst.preview);
            }
            if(!payload.noState) {
              context.commit('item', {value: nst });
            }
            return nst;
        },
        
        async list(context, payload) {
          let filter = null;  
          if(payload?.public) {
            filter = { public: { eq: true } };
          }
          const c = await API.graphql(graphqlOperation(`
            query ListNewsletterTemplates(
              $filter: ModelNewsletterTemplateFilterInput
              $limit: Int
              $nextToken: String
            ) {
              listNewsletterTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
                items {
                  id
                  name
                  public
                  preview
                  order
                }
                nextToken
              }
            }
          `, { filter, nextToken: payload?.nextToken, limit: 100 }));

          let items = c.data.listNewsletterTemplates.items;
          for(let i = 0; i < items.length; i++) {
            let item = items[i];
            if(item.preview) {
              item.preview = await Storage.get(item.preview);
            }
          }
          context.commit('list', {value: items, append: !!payload?.nextToken });
          context.commit('listDirty', {value: false});
          context.commit('publicOnly', {value: payload?.public || false });
          context.commit('nextToken', {value: c.data.listNewsletterTemplates.nextToken });
          if(context.state.nextToken) {
            await context.dispatch('list', {public: payload?.public, nextToken: context.state.nextToken });
          }
        },

        async create(context, payload) {
          var reqparams = {
            public: false
          }
          Object.assign(payload, reqparams);
          var r = await API.graphql(graphqlOperation(`
            mutation CreateNewsletterTemplate(
              $input: CreateNewsletterTemplateInput!
              $condition: ModelNewsletterTemplateConditionInput
            ) {
              createNewsletterTemplate(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: payload}));
          context.commit('listDirty', {value: true});
          return r.data.createNewsletterTemplate;
        },
        
        async duplicate(context, payload) {
          let t = await context.dispatch('get', { id: payload.id, noState: true });
          delete(t.id);
          delete(t.preview);
          delete(t.order);
          t.name += ` (${payload.localizedTitle || 'Copy'})`;
          if(t.unlayerData) {
            t.unlayerData = JSON.stringify(t.unlayerData);
          }
          return await context.dispatch('create', t);
        },

        async updateFields(context, payload) {
          if(payload.fields.grapesJSData) {
            payload.fields.grapesJSData = JSON.stringify(payload.fields.grapesJSData);
          }
          if(payload.fields.unlayerData) {
            payload.fields.unlayerData = JSON.stringify(payload.fields.unlayerData);
          }
          await API.graphql(graphqlOperation(`
            mutation UpdateNewsletterTemplate(
              $input: UpdateNewsletterTemplateInput!
              $condition: ModelNewsletterTemplateConditionInput
            ) {
              updateNewsletterTemplate(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: Object.assign({ id: context.state.item.id }, payload.fields )}));
          context.commit('listDirty', {value: true});
          return await context.dispatch('get', { id: context.state.item.id });
          //return r.data.updateDomain;
        },

        async remove(context, payload) {
          await API.graphql(graphqlOperation(`
            mutation DeleteNewsletterTemplate(
              $input: DeleteNewsletterTemplateInput!
              $condition: ModelNewsletterTemplateConditionInput
            ) {
              deleteNewsletterTemplate(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: { id: payload.id } }));
          await context.dispatch('list');
          //return r.data.updateDomain;
        },

        async uploadPreview(context, payload) {
          //console.dir(payload);
          let segments = payload.file.name.split('.');
          let ext = segments[segments.length-1]; 
          var result = await Storage.put(`campaigns/common/template-${context.state.item.id}-preview.${ext}`, payload.content ?? payload.file, {
              level: 'public',
              acl: 'public-read',
              contentType: payload.file.type,
              // cache for a long time
              cacheControl: 'public, max-age=15768000'
          });
         return result.key;
      },

      /*
      async getUnlayerPreview(context, payload) {
        
        let mt = {};
        Object.values(unlayer.mergeTags).forEach(v => mt[v.value] = v.sample);

        // TODO move to backend so API key is not available in source code (add to ses template handler?)
        const options = {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + btoa(`xPXplkWPdWrpA12YditslGqTsxZLtRbwb1kpNgxhhA3Igfx6pAK3f5WN0G3GvxfN:`)},
          body: JSON.stringify({
            displayMode: 'email',
            design: payload.template,
            mergeTags: mt
          })
        };
        
        let response = await (await fetch('https://api.unlayer.com/v2/export/image', options)).json();
        console.debug('preview response', response);
        return response.data.url;
      },
      */
      async getS3Link(context, payload) {
        var url = await Storage.get(payload.key);
        return url.substr(0, url.indexOf('?'));
      }
    }
}